import type { FaireProductEntity } from "../../entity_types/product";

export const p_zg6eqem26r: FaireProductEntity = {
  token: "p_zg6eqem26r",
  type: "product",
  name: "Bronson French Roast",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/3bcd320a7a6272c15596e5a0af54f8229f6d4085bf0fe3f1842f52dbd1b987dc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a91045b184d040d2af876e48ce43763e0c92315bed1a5b2a887d367b334fa31.png",
    "https://cdn.faire.com/fastly/0b68e993130a07b90c1afe3471af26958aaf7e2103ea6fb816348141fcb0758b.png"
  ],
  priceDollars: 79,
  description: "Our take on French Roast. Enjoy silky dark chocolate and raw sugar sweetness with our darkest roast. It pairs well with cream and sugar. Anyone who enjoys an extra bold coffee will love this.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:19.912Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
